import React, { memo, useCallback, useMemo } from "react"
import { FunnelIcon } from "@heroicons/react/24/outline"

const AyudaFilter = ({ filters, setFilters, showFilters }) => {
  const handleFilterChange = useCallback(
    (key, value) => {
      setFilters({ ...filters, [key]: value })
    },
    [filters, setFilters]
  )

  const handleClearFilters = useCallback(() => {
    setFilters({
      gender: "",
      civil_status: "",
      vulnerable_sector: "",
      age: "",
      monthly_income: "",
    })
  }, [setFilters])

  return (
    <div
    // className='bg-white rounded-lg shadow mb-6 p-6 animate-in slide-in-from-top duration-300'
    >
      <div className='flex items-center mb-4'>
        <FunnelIcon className='w-5 h-5 mr-2 text-blue-600' />
        <h3 className='text-lg font-medium text-gray-900'>
          Ayuda Recipient Filter
        </h3>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-5 gap-4'>
        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Monthly Income
          </label>
          <select
            value={filters.monthly_income}
            onChange={(e) =>
              handleFilterChange("monthly_income", e.target.value)
            }
            className='w-full border border-gray-300 rounded-lg px-4 py-3 '
          >
            <option value='all'>All Income</option>
            <option value='0-4000'>0-900</option>

            <option value='1000-5000'>1000-5000</option>
            <option value='6000-15000'>6000-15000</option>
            <option value='16000-30000'>16000-30000</option>
            <option value='>30000'>above 30000</option>
          </select>
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Gender
          </label>
          <select
            value={filters.gender}
            onChange={(e) => handleFilterChange("gender", e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-3 '
          >
            <option value='all'>All Genders</option>
            <option value='male'>Male</option>
            <option value='female'>Female</option>
            {/* <option value='other'>Other</option> */}
          </select>
        </div>

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Civil Status
          </label>
          <select
            value={filters.civil_status}
            onChange={(e) => handleFilterChange("civil_status", e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-3 '
          >
            <option value='all'>All Status</option>
            <option value='single'>Single</option>
            <option value='married'>Married</option>
            <option value='divorced'>Divorced</option>
            <option value='widowed'>Widowed</option>
            <option value='separated'>Separated</option>
          </select>
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Age
          </label>
          <select
            value={filters.age}
            onChange={(e) => handleFilterChange("age", e.target.value)}
            className='w-full border border-gray-300 rounded-lg px-4 py-3 '
          >
            <option value='all'>All Age</option>
            <option value='0-16'>0-16</option>
            <option value='17-30'>17-30</option>
            <option value='31-45'>31-45</option>
            <option value='>45'>Above 45</option>
          </select>
        </div>
        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>
            Vulnerable Sector
          </label>
          <select
            value={filters.vulnerable_sector}
            onChange={(e) =>
              handleFilterChange("vulnerable_sector", e.target.value)
            }
            className='w-full border border-gray-300 rounded-lg px-4 py-3 '
          >
            <option value='all'>All Sector</option>
            <option value='soloparent'>Solo Parent</option>
            <option value='senior'>Senior Citizen</option>
            <option value='pwd'>Person with Disability</option>
            <option value='indigenous'>Indigenous Group</option>
          </select>
        </div>
        {/* <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Search
            </label>
            <input
              type='text'
              placeholder='Search recipients...'
              value={filters.search}
              onChange={(e) => handleFilterChange("search", e.target.value)}
              className='w-full border border-gray-300 rounded-lg px-4 py-3'
            />
          </div> */}
      </div>

      <div className='mt-6 flex justify-between items-center'>
        <div className='text-sm text-gray-600'>
          Showing filtered results based on selected criteria
        </div>
        <button
          onClick={() =>
            setFilters({
              gender: "",
              civil_status: "",
              vulnerable_sector: "",
              age: "",
              monthly_income: "",
            })
          }
          className='inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors'
        >
          Clear All Filters
        </button>
      </div>
    </div>
  )
}

export default memo(AyudaFilter)
